module.exports = __webpack_public_path__ + "static/media/homepage_atf_2.abbc0cca.png";